
import React from 'react';
import { motion } from 'framer-motion';
import { MoveRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { images } from '@/assets/images';

interface CalculatorLayoutProps {
  children: React.ReactNode;
  onNavigateToBuyingPower: () => void;
}

export const CalculatorLayout: React.FC<CalculatorLayoutProps> = ({ 
  children, 
  onNavigateToBuyingPower 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/20 to-slate-950">
      <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-14 items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img
              src={images.equiforgeLogoFlat}
              alt="EquiForge"
              className="h-10 md:h-12 lg:h-14 w-auto object-contain drop-shadow-md"
            />
            <h1 className="text-lg font-semibold">EquiForge™ Estimator Engine</h1>
          </Link>
          <motion.button
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            onClick={onNavigateToBuyingPower}
            className="flex items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
            aria-label="Go to SmartBuy Analyzer"
          >
            <span>SmartBuy Analyzer</span>
            <MoveRight className="h-4 w-4" />
          </motion.button>
        </div>
      </header>
      <main className="container py-6">
        {children}
      </main>
    </div>
  );
};
